import { useFormContext } from 'react-hook-form';

import TextArea from 'components/field/TextArea';
import FormItem from 'components/form/FormItem';
import Maps from 'components/maps/Maps';

/**
 * @author @omerrkosar
 */

export const AreaLocation = ({ mode, setMap }) => {
	const viewMode = mode === 'view';

	const formMethods = useFormContext();

	const {
		formState: { isLoading: isFormLoading, isSubmitting }
	} = formMethods;

	const isLoading = isFormLoading || isSubmitting;

	return (
		<>
			<FormItem label="polygon" isLoading={isLoading} toolTip="areaform.polygon.tooltip">
				<TextArea name="polygon" disabled={viewMode} maxLength="65535" />
			</FormItem>
			<div style={{ width: '100%', height: 'calc(var(--vh, 1vh) * 60)' }}>
				<Maps setMap={setMap} />
			</div>
		</>
	);
};
